<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 20 20"
    role="presentation"
    :fill="iconColor"
    data-cy="svg--has-forklift">
    <defs>
      <path id="aforklift" d="m19.722 15.1h-4.7v-15.1h-1.155v15.1h-1.157v-2.312h-1.155v-3l-2.497-6.244h-7.902v8.089h-1.156v5.778h.058a2.894 2.894 0 0 0 2.83 2.31 2.894 2.894 0 0 0 2.832-2.31h1.213a2.314 2.314 0 0 0 2.312 2.31 2.314 2.314 0 0 0 2.31-2.31h1.156v-1.156h7.01v-1.156zm-17.41-10.4h5.964l2.124 5.31v1.961l-1.056-1.056.408-.409-.817-.817-1.634 1.634.817.817.409-.408 1.056 1.056h-1.832l-1.156-1.155h-4.284v-6.934zm.577 13.866a1.735 1.735 0 0 1 -1.733-1.733c0-.956.777-1.734 1.733-1.734s1.733.778 1.733 1.734-.777 1.733-1.733 1.733zm6.356 0a1.157 1.157 0 0 1 -1.156-1.155 1.157 1.157 0 0 1 2.311 0c0 .637-.518 1.155-1.155 1.155zm2-2.311a2.312 2.312 0 0 0 -2-1.156c-.854 0-1.6.466-2 1.156h-1.525a2.894 2.894 0 0 0 -2.831-2.311c-.65 0-1.25.216-1.733.58v-1.736h4.96l1.156 1.156h4.284v2.311zm-8.934 0h1.156v1.156h-1.157v-1.156z"/>
      <mask id="bforklift" fill="#fff">
        <use fill="none" xlink:href="#aforklift"/>
      </mask>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <use :fill="iconColor" fill-rule="nonzero" transform="matrix(-1 0 0 1 19.722 0)" xlink:href="#aforklift"/>
      <g :fill="iconColor" mask="url(#bforklift)">
        <path d="m0 0h20.16v20.16h-20.16z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
